<div class="messages-threads-view-wrapper h-100 flex flex-col">
  <div class="flex-1 min-h-0">
    @if (!(isLoading$ | async)) {
      <ng-scrollbar #scrollbar class="std-scrollbar" orientation="vertical" appearance="native">
        <div [ngClass]="{ 'mr-3': scrollbar.isVerticallyScrollable() }">
          <div class="main-message-body py-3">
            <app-message-item [hideReplies]="true" [message]="threadMessages?.mainMessage"></app-message-item>
          </div>
          @for (threadMessage of threadMessages?.replies; track trackByFn($index, threadMessage)) {
            <div class="py-3 pl-6 border-b border-solid border-navy-300">
              <app-message-item [hideReplies]="true" [message]="threadMessage"></app-message-item>
            </div>
          }
        </div>
      </ng-scrollbar>
    }

    @if (isLoading$ | async) {
      <div class="h-100 flex justify-center items-center">
        <span class="icon-refresh animate-spin text-size_title_xl text-navy-600"></span>
      </div>
    }
  </div>

  <div class="border-separator"></div>
  @if (!draftLoaded) {
    <div class="py-2 flex w-full items-center justify-center h-[244px]">
      <div class="notify-msg animate-pulsating-border">
        <div class="icon-logo-box-hex"></div>
      </div>
    </div>
  } @else {
    <app-rich-text-editor
      [editorValue]="editorValue"
      (editorValueChange)="onEditorValueChange($event)"
      [userMentions]="usersData.discussionMembers"
      [projectMentions]="projectMentions$ | async"
      [allowFileUpload]="true"
      [filesToUpload]="filesToUpload$ | async"
      (filesToUploadChange)="registerFileUpload($event)"
      (removedFileToUpload)="removeFile($event)"
      enterKeyPressBehaviour="custom"
      (enterKeyPress)="footerService.emitSave()"
      class="h-52"
    >
      <div class="right-button-container">
        <app-simple-button (click)="footerService.emitSave()" buttonStyle="color_accent_filled">Send</app-simple-button>
      </div>
    </app-rich-text-editor>
  }
</div>
